<template>
  <div class="box">
    <Header @search="onSearch" />
    <div class="page">
      <p class="cms-page-title">{{ $t('身份验证') }}</p>
      <div class="tips">
        <p>
          {{ $t('媒体记者注册后，需等待终审通过才能访问新闻中心媒体板块') }}
        </p>
        <p>
          {{ $t('如果您还未注册，或尚未收到终审通过通知，请访问') }}
          <a :href="mediaLink" target="_blank" @click.prevent="mediaRegister">
            {{ $t('媒体注册系统') }}</a
          >
          {{ $t('进行注册或查询审核状态。') }}
        </p>
      </div>
      <el-form class="main">
        <el-form-item>
          <el-input
            type="text"
            v-model.trim="idNo"
            :placeholder="$t('请输入您用于注册媒体记者的身份证件号')"
          />
        </el-form-item>
        <el-button class="btn" @click="check" size="large">
          {{ $t('验证并登录') }}
        </el-button>
      </el-form>
    </div>
    <Footer />
  </div>
</template>

<script>
// import '@/assets/css/home.css'
import { setToken } from '@/utils/auth'
import getTranslation from '@/locale/getTranslation'
import Header from '@/views/news/components/headerBanner'
import Footer from '@/views/news/components/footer'
import { mediaLoginApi } from '@/api/news'
export default {
  data() {
    return {
      idNo: '',
      mediaLink: process.env.VUE_APP_MEDIA
    }
  },
  components: {
    Header,
    Footer
  },
  methods: {
    onSearch(input) {
      this.$router.push({
        name: 'pc_search',
        query: {
          search: input
        }
      })
    },
    async check() {
      try {
        const {
          accessToken = '',
          refreshToken = '',
          user = '',
          account = ''
        } = await mediaLoginApi({
          idNo: this.idNo
        })
        setToken({ accessToken, refreshToken, user, account })

        // 判断URL中是否有returnUrl参数，如果有则跳转到该地址，否则跳转到新闻中心
        const rawReturnUrl = this.$route.query.returnUrl
        const returnUrl =
          typeof rawReturnUrl === 'string' && rawReturnUrl
            ? decodeURIComponent(rawReturnUrl)
            : ''
        if (returnUrl) {
          window.location.href = returnUrl
          return
        }

        this.$notify({
          type: 'success',
          message: getTranslation('验证成功，正在跳转新闻中心！'),
          duration: 2000
        })
        this.$router.push('/mobile/news')
      } catch (error) {
        if (error.status === 400) {
          this.$router.push('/web/login/error')
        } else {
          console.log(error)
          this.$toast(error.data.message)
        }
      }
    },
    mediaRegister() {
      window.location.href =
        'https://zhizheng.ciftis.org/query/form?paperType=1&code=5mbif8xxqx&type=media'
      // this.$alert(this.$t('媒体记者注册已关闭'), {
      //   confirmButtonText: this.$t('确定'),
      //   callback: () => {}
      // })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
.box {
  width: 100%;
  font-size: 14px;
}
.page {
  border-top: 1px solid #ddd;
  width: 100%;
  // height: 84vh;
  padding-top: 50px;
  display: flex;
  flex-direction: column;
  background: #fff;
  .tips {
    background: #fdfcec;
    text-align: center;
    margin: 0 auto;
    border: 1px solid #fe8c01;
    color: #fe8c01;
    width: 780px;
    font-size: 14px;
    line-height: 20px;
    padding: 10px 0;
    p {
      border: 0;
    }
    a {
      color: red !important;
      text-decoration: underline;
    }
  }
  .cms-page-title {
    padding: 20px 0;
    font-size: 24px;
    text-align: center;
    margin-bottom: 30px;
    border: 0;
    color: #000;
  }
  .main {
    margin: 50px auto;
    width: 360px;
    .el-input__inner {
      width: 340px;
      height: 40px;
      font-size: 14px;
      color: #999999;
    }
    .btn {
      height: 40px;
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 14px;
      border-radius: 6px;
      @include linearBg();
      margin-top: 15px;
    }
  }
  .el-button span {
    color: #fff;
  }
}
</style>

<style lang="scss">
$color-primary: #fe8c01;
$color-primary-light: #ffb301;

$linear-gradient: linear-gradient(
  to right,
  $color-primary-light,
  $color-primary
);

.el-button--primary {
  background-image: $linear-gradient;
  border: 0;
  line-height: 16px;
}
</style>
